import { Link, Links } from '_types/public-api';

export const services = (
  links: Links | null | undefined,
  servicesType: string,
  callback: (param1: Links | null | undefined, param2: string) => Link[] | undefined,
) => {
  return callback(links, servicesType);
};
